// store/AppStore.ts
import { create } from "zustand";

type AppStore = {
  selectedCategory: string | null;
  setSelectedCategory: (category: string | null) => void;
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
  // 국가별 현재 슬라이드 인덱스를 저장
  countrySlides: Record<string, number>;
  setCountrySlide: (country: string, slideIndex: number) => void;
  getCountrySlide: (country: string) => number;
};

export const useAppStore = create<AppStore>((set, get) => ({
  selectedCategory: "",
  setSelectedCategory: (category) => set({ selectedCategory: category }),
  searchTerm: "",
  setSearchTerm: (searchTerm) => set({ searchTerm }),
  countrySlides: {},
  setCountrySlide: (country, slideIndex) =>
    set((state) => ({
      countrySlides: {
        ...state.countrySlides,
        [country]: slideIndex,
      },
    })),
  getCountrySlide: (country) => {
    const { countrySlides } = get();
    return countrySlides[country] || 0;
  },
}));
